import { render, staticRenderFns } from "./ProductSystemManagement.vue?vue&type=template&id=87cfcba0"
import script from "./ProductSystemManagement.vue?vue&type=script&lang=ts"
export * from "./ProductSystemManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports